<template>
  <div :style="`${'height: 100%; background-color: '+backgroundColor}`"
       @drop="(event) => dragToSubmitCmp(event, componentIndex)"
       @dragover="allowSignalMeasureDrop">
    <div class="cmp-handle" style="z-index: 999">
      <el-dropdown>
        <span class="el-dropdown-link">
          <i class="el-input__icon el-icon-more"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="settingVisible=true"
                            style="text-align: center">设置
          </el-dropdown-item>
          <el-dropdown-item @click.native="editSignalName"
                            style="text-align: center">重命名
          </el-dropdown-item>
          <el-dropdown-item @click.native="select()"
                            style="text-align: center">{{selcted ? '取消选中' : '选中'}}
          </el-dropdown-item>
          <el-dropdown-item @click.native="handleCmp('delete',componentIndex)"
                            style="text-align: center">删除
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-tooltip :content="uDataSources.text" placement="top-start" :open-delay="1000">
      <p @dblclick="(event)=>dbClick(event,uDataSources.key)"
         @click="(event)=>clickSelect(event)"
         v-if="!edit" :style="`${'cursor: pointer; font-size: '+fontSize +'px;color: '+fontColor}`">{{uDataSources.text}}</p>
    </el-tooltip>
    <el-input v-if="edit" v-model="uDataSources.text" size="mini" @keyup.enter.native="saveTriggerName">
    </el-input>
    <div @click="clickEvent">
      <Icon :style="`${'font-size: 36px;cursor: pointer;color: '+triggerColor}`" type="ios-radio-button-on"/>
    </div>
    <el-dialog
        :append-to-body="true"
        :visible.sync="settingVisible"
        title="设置"
        width="30%">
      <el-row>
        <el-col :span="8">
          <span style="font-size: 16px;display: block">字体大小</span>
          <el-input-number size="mini" v-model="exampleFontSize" :min="12" :max="30" controls-position="right" style="width: 80%"></el-input-number>
        </el-col>
        <el-col :span="8">
          <span style="font-size: 16px;display: block">颜色</span>
          <el-color-picker size="mini" v-model="exampleFontColor" show-alpha></el-color-picker>
        </el-col>
        <el-col :span="8">
          <span style="font-size: 16px;display: block">预览</span>
          <span :style="`${'font-size: '+exampleFontSize +'px;color: '+exampleFontColor}`">信号名</span>
        </el-col>
      </el-row>
      <br>
      <el-row>
        <el-col :span="16">
          <span style="font-size: 16px;display: block">ON颜色</span>
          <el-color-picker v-model="onColor" show-alpha></el-color-picker>
        </el-col>
        <el-col :span="8">
          <span style="font-size: 16px;display: block">预览</span>
          <Icon :style="`${'font-size: 36px;color: '+onColor}`" type="ios-power"/>
        </el-col>
      </el-row>
      <br>
      <el-row>
        <el-col :span="16">
          <span style="font-size: 16px;display: block">OFF颜色</span>
          <el-color-picker v-model="offColor" show-alpha></el-color-picker>
        </el-col>
        <el-col :span="8">
          <span style="font-size: 16px;display: block">预览</span>
          <Icon :style="`${'font-size: 36px;color: '+offColor}`" type="ios-power"/>
        </el-col>
      </el-row>
      <span class="dialog-footer" slot="footer">
        <el-button @click="settingVisible = false">取 消</el-button>
        <el-button @click="settingVisible = false,saveTriggerConfig()" type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import { PROJECT_NODE_TYPE } from '@/common/enums';
import projectDetailAPI from '@/api/projectDetail';

export default {
  name: 'Trigger',
  props: {
    componentIndex: {
      type: Number,
    },
    itemData: {
      type: Object,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      on: false,
      onColor: '#F56C6C',
      offColor: '#303133',
      edit: false,
      settingVisible: false,
      fontColor: '#303133',
      exampleFontColor: '#303133',
      fontSize: 15,
      exampleFontSize: 15,
      uDataSources: {
        text: '信号名',
        key: '',
        value: 0,
      },
    };
  },
  methods: {
    ...mapActions('Engineering', ['deleteCpt']),
    ...mapMutations('Engineering', ['addSubmitCmp', 'setAnchorKeyWord', 'setAnchorPointId', 'selectCpt']),
    handleCmp(command, index) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      switch (command) {
        case 'delete':
          this.deleteCpt({ index });
          break;
        default:
          break;
      }
    },
    dragToSubmitCmp(event, componentIndex) {
      // if (this.getCurCmpStatus) {
      //   this.$message({
      //     message: '当前面板正在运行，请先进行关闭',
      //   });
      //   return;
      // }
      const dragNode = JSON.parse(event.dataTransfer.getData('dragNodeData'));
      const { id, dtype, text } = dragNode;
      this.addSubmitCmp({
        id, dtype, text, componentIndex,
      });
    },
    allowSignalMeasureDrop(event) {
      event.preventDefault();
      if (this.dragTreeNodeType === PROJECT_NODE_TYPE.DBC_TRIGGER) {
        event.dataTransfer.dropEffect = 'copy';
      } else {
        event.dataTransfer.dropEffect = 'none';
      }
    },
    dbClick(event, key) {
      event.stopPropagation();
      const arr = key.split('.');
      const str = arr.join('');
      const arr2 = str.split(':');
      const str2 = arr2.join('');
      this.setAnchorKeyWord(key.substring(key.lastIndexOf('.') + 1)); // 信号名
      setTimeout(() => {
        this.setAnchorKeyWord('');
        this.setAnchorPointId('');
        setTimeout(() => {
          this.setAnchorPointId(str2);
        }, 50);
      }, 50);
    },
    async sendTrigger() {
      const projectId = this.$store.state.Engineering.projectId;
      const triggerId = this.uDataSources.key;
      await projectDetailAPI.sendTrigger(projectId, triggerId)
        .then(() => {
          this.$message({
            message: `${this.uDataSources.text}触发成功！`,
            type: 'success',
          });
        }).catch(() => {
          this.$message.error(`${this.uDataSources.text}触发失败！`);
        });
    },
    async saveTriggerConfig() {
      this.size = '';
      this.step = 1;
      this.fontSize = this.exampleFontSize;
      this.fontColor = this.exampleFontColor;
      const projectId = this.$store.state.Engineering.projectId;
      const panelId = this.$store.state.Engineering.panelId;
      const componentStyleParams = [];
      const componentStyleParam = {
        componentId: this.itemData.cid,
        wordSize: this.fontSize,
        wordColor: this.fontColor,
        componentSize: this.size,
        step: this.step,
      };
      componentStyleParams.push(componentStyleParam);
      console.log({ projectId, panelId, componentStyleParams });
      await projectDetailAPI.saveCptStyle(projectId, panelId, componentStyleParams)
        .catch((err) => {
          this.$message.error('保存失败！');
        });
    },
    async saveTriggerName() {
      this.edit = false;
      const projectId = this.$store.state.Engineering.projectId;
      const panelId = this.$store.state.Engineering.panelId;
      const componentId = this.itemData.cid;
      const signalKey = this.uDataSources.key;
      const name = this.uDataSources.text;
      console.log({ projectId, panelId, componentId, signalKey, name });
      await projectDetailAPI.saveCptName(projectId, panelId, componentId, signalKey, name)
        .catch((err) => {
          this.$message.error('信号名保存失败！');
        });
    },
    clickEvent() {
      if (this.getCurCmpStatus) {
        this.on = true;
        this.sendTrigger();
        setTimeout(() => {
          this.on = false;
        }, 300);
      } else {
        this.$message({
          message: '当前工程尚未开始，请先开始工程！',
        });
      }
    },
    editSignalName() {
      if (this.uDataSources.key !== '') {
        this.edit = true;
      } else {
        this.$message({
          message: '请先绑定信号！',
          type: 'warning',
        });
      }
    },
    select() {
      const id = this.itemData.cid;
      this.selectCpt(id);
    },
    clickSelect(event) {
      if (event.ctrlKey) {
        this.select();
      }
    },
  },
  computed: {
    ...mapGetters('Engineering', ['getCurCmpStatus']),
    ...mapState('Engineering', ['dragTreeNodeType']),
    dataSou() {
      return this.itemData.dataSources || [];
    },
    styleSetting() {
      return this.itemData.styleSetting || [];
    },
    selcted() {
      const id = this.itemData.cid;
      if (this.$store.state.Engineering.selectedCpts.indexOf(id) > -1) {
        return true;
      }
      return false;
    },
    triggerColor() {
      if (this.on) {
        return this.onColor;
      }
      return this.offColor;
    },
    backgroundColor() {
      if (this.selcted) {
        return 'rgba(127,204,232,0.21)';
      }
      return '';
    },
  },
  watch: {
    dataSou: {
      handler(newDataSou) {
        const self = this;
        if (newDataSou.length > 0) {
          self.uDataSources.text = newDataSou[0].text;
          self.uDataSources.key = newDataSou[0].key;
        }
      },
      deep: true,
      immediate: true,
    },
    styleSetting: {
      handler(setting) {
        const self = this;
        if (setting.length > 0) {
          self.size = setting[setting.length - 1].size;
          self.step = setting[setting.length - 1].step;
          self.fontSize = setting[setting.length - 1].fontSize;
          self.fontColor = setting[setting.length - 1].fontColor;
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
  .el-input__icon {
    /*line-height: 25px;*/
    line-height: 20px;
    opacity:0;
  }
  .cmp-handle {
    position: absolute;
    top: 0;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/engineering/Trigger.vue